/***
 *
 *   LANDING — shared section styles
 *   Phase 10 — align container / type scale with reference public chrome
 *   (max-w-6xl).
 *
 *   The striped `placeholder` / `placeholderLabel` / `placeholderSpec` entries
 *   are gone: hero and intake now render real captures. The --stripe token they
 *   read is still declared in src/css/tokens.css and now has no consumer.
 *
 **********/

const Style = {
    container: 'relative mx-auto max-w-6xl px-6',

    section: 'border-t border-border py-16 md:py-24',
    sectionSurface: 'border-t border-border bg-surface py-16 md:py-24',

    eyebrow: 'mb-3.5 text-xs font-semibold uppercase tracking-[0.08em] text-primary-500',
    title: 'm-0 text-3xl font-bold tracking-[-0.02em] text-text-primary md:text-4xl',
    lede: 'text-base leading-relaxed text-text-secondary md:text-lg',

    split: 'grid gap-14 md:gap-16 lg:grid-cols-2',

    ctaPrimary: `inline-block rounded-lg bg-primary-600 px-5 py-3 text-[15px] font-semibold text-white
    no-underline transition-colors duration-150 ease-out hover:bg-primary-700`,
    ctaSecondary: `inline-block rounded-lg border border-border bg-surface px-5 py-3 text-[15px]
    font-medium text-text-primary no-underline transition-colors duration-150 ease-out hover:border-primary-400`,
};

export default Style;
